<template>
  <div id="contenedor-contrato-editar-actividad">
    <v-form
      v-model="formularioValido"
      ref="editarContratoActividad">
      <v-card>
        <v-card-title class="secondary--text">
          Editar actividad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="8">
              <custom-select
                v-model="actividad.idContratoFrente"
                :items="mixGetContratoFrentes"
                item-text="descripcion"
                item-value="id"
                label="Frente"
                :rules="[mixReglas.requerido]">
              </custom-select>
            </v-col>
            <custom-date-picker
              cols="12"
              md="4"
              v-model="actividad.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <v-col
              cols="12"
              md="8">
              <v-radio-group
                v-model="actividad.tipo"
                label="Tipo: "
                row
                hide-details>
                <v-radio
                  label="Diario"
                  :value="1"
                  hide-details>
                </v-radio>
                <v-radio
                  label="Informe"
                  :value="2"
                  color="info"
                  hide-details>
                </v-radio>
                <v-radio
                  label="Album"
                  :value="3"
                  hide-details>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-switch
                v-model="actividad.esProblema"
                inset
                :disabled="actividad.tipo !== 1"
                hide-details
                color="error"
                label="Existe problema">
              </v-switch>
            </v-col>
            <custom-text-area
              v-model="actividad.descripcion"
              cols="12"
              label="Descripción"
              rows="4"
              :rules="[mixReglas.requerido]">
            </custom-text-area>
          </v-row>
          <v-divider></v-divider>
          <!-- Fotos de la actividad -->
          <div id="contenedor-album-fotografico">
            <v-row>
              <!-- Listado de imagenes -->
              <template
                v-for="(imagen, index) in imagenes">
                <template>
                  <v-col
                    cols="auto"
                    class="pa-1"
                    :key="`imagen-${index}`">
                    <v-img
                      :src="imagen"
                      height="180"
                      width="180"
                      contain
                      class="blue-grey darken-4">
                      <div class="contenedor-imagenes-remover-imagen">
                        <v-btn
                          small
                          icon
                          dark
                          @click="removerImagen(index)">
                          <v-icon>
                            mdi-close-circle
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                  </v-col>
                </template>
              </template>
              <!-- Seleccionar imagen -->
              <v-col
                cols="auto">
                <div
                  class="contenedor-imagenes-agregar"
                  @click="$refs.seleccionarAnexo.click()">
                  <v-img
                    src="@/assets/add-img-img.png"
                    contain
                    height="100"
                    width="100">
                  </v-img>
                </div>
              </v-col>
              <custom-text-area
                v-model="actividad.comentarioFotografico"
                cols="12"
                label="Pie de foto"
                rows="2">
              </custom-text-area>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoActividad"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <input
      type="file"
      ref="seleccionarAnexo"
      id="anexo"
      class="d-none"
      accept="image/jpeg, image/png, image/bmp"
      multiple
      @change="preCargarImagenes">
  </div>
</template>

<script>
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixReporteActividades from './mixReporteActividades';

export default {
  name: 'ContratoEditarActividad',
  mixins: [mixReporteActividades],
  props: {
    actividadContratoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomSelect,
    CustomTextArea,
    CustomButton,
    CustomDatePicker,
  },
  data() {
    return {
      // id contrato para que no de error query de frentes de contrato del mix
      idContrato: this.actividadContratoEditar.idContrato,
      formularioValido: false,
      enviandoFormulario: false,
      imagenes: [],
      actividad: {
        idContratoFrente: this.actividadContratoEditar.idContratoFrente,
        fecha: this.actividadContratoEditar.fecha,
        descripcion: this.actividadContratoEditar.descripcion,
        tipo: this.actividadContratoEditar.tipo,
        esProblema: this.actividadContratoEditar.esProblema,
        comentarioFotografico: this.actividadContratoEditar.comentarioFotografico,
        imagenes: this.actividadContratoEditar.imagenes,
      },
    };
  },
  mounted() {
    this.crearUrlDeLasImagenesSeleccionadas();
  },
  methods: {
    preCargarImagenes() {
      const { imagenes } = this.actividad;
      // get las fotos
      const fileInput = document.getElementById('anexo');
      imagenes.push(...fileInput.files);

      for (let i = 0; i < fileInput.files.length; i += 1) {
        const url = URL.createObjectURL(fileInput.files[i]);
        this.imagenes.push(url);
      }
    },
    crearUrlDeLasImagenesSeleccionadas() {
      let { imagenes } = this.actividad;
      if (typeof (imagenes) === 'string') {
        imagenes = JSON.parse(imagenes);
      }
      for (let i = 0; i < imagenes.length; i += 1) {
        if (typeof (imagenes[i]) === 'string') {
          const url = `${this.$urlFileServer}/${imagenes[i]}`;
          this.imagenes.push(url);
        } else {
          const url = URL.createObjectURL(imagenes[i]);
          this.imagenes.push(url);
        }
      }
    },
    removerImagen(index) {
      this.imagenes.splice(index, 1);
      this.actividad.imagenes.splice(index, 1);
    },
    limpiarFormulario() {
      this.$refs.editarContratoActividad.reset();
      this.imagenes = [];
      this.actividad.esProblema = false;
      this.actividad.imagenes = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-vista-previa {
  position: relative;
}
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagenes-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagenes-agregar:hover {
  border: 2px solid #ccc;
}
</style>
